import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ProductCard from "@/components/ProductCard";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { ChevronLeft, Calendar } from "lucide-react";

export default function BlogArticle() {
  const { slug } = useParams();
  const { lang, t } = useLang();
  const [data, setData] = useState(null);

  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setData(r.data)); }, [slug]);

  if (!data) return (<div className="min-h-screen bg-xd-light"><Header /><div className="text-center py-20 text-xd-muted">{t("pdp_loading")}</div></div>);
  const p = data.post;
  const localeDate = lang === "it" ? "it-IT" : lang === "fr" ? "fr-FR" : lang === "de" ? "de-DE" : lang === "es" ? "es-ES" : "en-GB";

  return (
    <div className="min-h-screen bg-xd-light">
      <Header />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
        <Link to="/blog" className="text-xs text-xd-muted hover:text-xd-cyanHover inline-flex items-center gap-1"><ChevronLeft className="w-3 h-3" /> {t("blog_all_articles")}</Link>
        <div className="mt-4 font-mono-tech text-[10px] uppercase tracking-widest text-xd-cyanHover">{p.category}</div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold mt-2 leading-tight" data-testid="blog-article-title">{p.title}</h1>
        <div className="flex items-center gap-2 mt-3 text-xs text-xd-muted"><Calendar className="w-3.5 h-3.5" /> {new Date(p.published_at).toLocaleDateString(localeDate)}</div>

        <img src={p.cover_image} alt={p.title} className="w-full aspect-[16/9] object-cover rounded-2xl mt-6" />

        <div className="prose prose-slate max-w-none mt-8 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:mt-8 [&_h2]:mb-3 [&_p]:leading-relaxed [&_p]:mt-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mt-3 [&_strong]:font-semibold" dangerouslySetInnerHTML={{ __html: p.content }} />
      </article>

      {data.related_products?.length > 0 && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
          <div className="font-display text-2xl font-semibold mb-6">{t("blog_related_products")}</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {data.related_products.map((pr) => <ProductCard key={pr.id} product={pr} />)}
          </div>
        </section>
      )}

      <Footer />
    </div>
  );
}
